import './Freq.css'
import { useMemo, useState, useEffect } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, Dropdown, Row, Col, Container } from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Chart from '../Chart'
import doRequest from '../../../requests/requests'
import { DraggableModalDialog } from '../DraggableModalDialog'
import { Resizable } from "re-resizable"

function Freq({ freq, unsetFreq, children }) {
    const originalLink = freq?.links?.find((link) => link?.rel.includes('original'))?.href
    const [freqNumber, setFreqNumber] = useState(0)
    // const [modalWidth, setModalWidth] = useState('auto');

    const layout = {
        title: 'Natural frequency',
        autosize: true,
        margin: { t: 80, b: 80, l: 50, r: 20 },
        xaxis: { title: 'Date' },
        yaxis: { title: 'Frequency (Hz)' },

    };

    const layoutWater = {
        title: ' Water Level',
        autosize: true,
        margin: { t: 80, b: 80, l: 50, r: 20 },
        xaxis: { title: 'Date' },
        yaxis: { title: 'Water Level (hm)' },

    };

    // useEffect(() => {
    //     const handleResize = () => {
    //         const modalBodyWidth = document.querySelector('.fn-modal-body')?.clientWidth;
    //         setModalWidth(modalBodyWidth ? `${modalBodyWidth}px` : 'auto');
    //     };
    //     window.addEventListener('resize', handleResize);
    //     handleResize(); // Initialize modal width
    //     console.log("resize")
    //     return () => window.removeEventListener('resize', handleResize);
    // }, [modalWidth]);


    const download = () => {
        doRequest({ onProgress: undefined, uri: originalLink, method: 'GET' }).then(
            async (res) => {
                if (res.status === 200) {
                    const file = URL.createObjectURL(await res.blob())
                    let a = document.createElement('a')
                    a.download = freq.properties.name
                    a.href = file
                    a.click()
                }
            }
        )
    }
    const graphData = useMemo(() => {
        const filteredFreqs = freq.properties.pFreq.freqs[freqNumber].filter(freq => freq !== 0);
        return [
            {
                type: 'scatter',
                name: `Natural Frequency ${freqNumber + 1}`,
                mode: 'markers',
                x: freq.properties.pFreq.dates,
                y: filteredFreqs/* freq.properties.pFreq.freqs[freqNumber] */,
                yaxis: 'y',
            },

        ];
    }, [freqNumber]);

    const graphDataWaterQuota = useMemo(() => {
        return [{
            type: 'scatter',
            name: `Water Level (hm)`,
            mode: 'lines',
            marker: { color: 'blue' },
            x: freq.properties.pFreq.dates,
            y: freq.properties.pFreq.quota.map((q) => q / 100),
            yaxis: 'y',
        },]

    }, []);


    /*  used to remove dragability for small resolutions */
    const modalDialog = window.innerWidth > 768 ? DraggableModalDialog : undefined;

    return (
        <Modal show={freq !== undefined} onHide={() => unsetFreq()} dialogAs={modalDialog} backdrop={'static'}>
            <Resizable className="modal-resizable" defaultSize={{ width: window.innerWidth > 768 ? "55vw" : "auto", height: "auto" }}  enable='false'  >
                <ModalHeader closeButton className='modal-header'>
                    <Modal.Title>{freq.properties.name}</Modal.Title>
                </ModalHeader>


                <ModalBody className='fn-modal-body'>
                    <Container className='fn-main-col'>
                        <Row>
                            <Dropdown className='dropdown'>
                                <Dropdown.Toggle variant="outline-primary">
                                    Select Frequency
                                </Dropdown.Toggle>
                                <Dropdown.Menu className='dropdown-menu'>
                                    {freq.properties.pFreq.freqs.map((f, i) => (
                                        <Dropdown.Item key={i} onClick={() => setFreqNumber(i)}>
                                            FN{i + 1}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Row>
                        <Row className='chart-container' style={{marginBottom: window.innerWidth > 768 ? "1em" : "0px"}}>
                            <Chart className='chart' data={graphData} layout={layout}  />
                        </Row>
                        <Row className='chart-container'>
                            <Chart className='chart' data={graphDataWaterQuota} layout={ layoutWater} />
                        </Row>
                    </Container>
                </ModalBody>


                <ModalFooter>
                    {originalLink && <Button onClick={() => download()}>Download</Button>}
                    {children}
                </ModalFooter>
            </Resizable>
        </Modal>
    )
}

export default Freq
